import { render, staticRenderFns } from "./digitRecords.vue?vue&type=template&id=f6087d3a&scoped=true"
import script from "./digitRecords.vue?vue&type=script&lang=js"
export * from "./digitRecords.vue?vue&type=script&lang=js"
import style0 from "./digitRecords.vue?vue&type=style&index=0&id=f6087d3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6087d3a",
  null
  
)

export default component.exports